"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const checkBallShouldIncrement = (props) => {
    if (!props ||
        (!props.noBall && !props.wide) ||
        (props.noBall && !props.noBall.isNoBall) ||
        (props.wide && !props.wide.isWide)) {
        return true;
    }
    if (props.noBall && props.noBall.rebowled === undefined)
        props.noBall.rebowled = true;
    if (props.wide && props.wide.rebowled === undefined)
        props.wide.rebowled = true;
    if ((props.noBall &&
        props.noBall.isNoBall &&
        (!props.noBall.rebowled ||
            (props.noBall.rebowled && !props.noBall.rebowledLastOver && props.isLastOverOfInnings)) &&
        (!props.noBall.rebowledLastOver || (props.noBall.rebowledLastOver && !props.isLastOverOfInnings))) ||
        (props.wide &&
            props.wide.isWide &&
            (!props.wide.rebowled || (props.wide.rebowled && !props.wide.rebowledLastOver && props.isLastOverOfInnings)) &&
            (!props.wide.rebowledLastOver || (props.wide.rebowledLastOver && !props.isLastOverOfInnings)))) {
        return true;
    }
    return false;
};
exports.default = checkBallShouldIncrement;
//# sourceMappingURL=checkBallShouldIncrement.js.map